import { FormattedMessage } from 'react-intl';

export const PaymentInformationBankTransfer = () => (
    <>
        <small className='payment-label'>
            <FormattedMessage id='intl-msg:marketplace.payment.bankTransfer.label.paymentType' />
            {': '}
        </small>
        <span className='payment-value text-bold'>
            <FormattedMessage id='intl-msg:marketplace.payment.method.bankTransfer' />
        </span>
    </>
);
